export default "__VITE_ASSET__Paky4UaY__"